import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class DateHelper {
  private static readonly ONE_WEEK_IN_MS = 1000 * 60 * 60 * 24 * 7;

  static oneWeekBeforeNow(): Date {
    return new Date(Date.now() - this.ONE_WEEK_IN_MS);
  }

  static oneWeekAfterNow(): Date {
    return new Date(Date.now() + this.ONE_WEEK_IN_MS);
  }

  //true if both null/undefined, or both Dates with identical timestamps
  static isSame(a?: Date | null, b?: Date | null): boolean {
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
    return a.getTime() === b.getTime();
  }

  //compare only calendar day in local time (ignores time-of-day)
  static isSameDay(a?: Date | null, b?: Date | null): boolean {
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  //a < b (by timestamp), false if either is null/undefined
  static isBefore(a?: Date | null, b?: Date | null): boolean {
    if (a == null || b == null) return false;
    return a.getTime() < b.getTime();
  }
}
